<div mat-dialog-title>
  <div class="dialog-caption">{{ data.caption }}</div>
  <button mat-dialog-close class="btn icon-close"></button>
</div>

<div mat-dialog-content>
  <div class="dialog-subtitle" [innerHTML]="data.message"></div>
</div>

<div mat-dialog-actions>
  <div class="w-100 align-h-space-between">
    <button [class.invisible]="data.hideCancel" mat-dialog-close class="btn link">{{ data.cancel }}</button>
    <button class="btn primary" (click)="confirm()">{{ data.confirm }}</button>
  </div>
</div>
